
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The HTML snippet of the question being asked to the candidate.`}</p>
    <p>{`Unsupported tags will be silently stripped when creating a questionnaire.`}</p>
    <p>{`This field has a maximum length of 1,000 characters.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;